// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__iiEE9","logo":"Advt_logo__keIND","phone":"Advt_phone__FBA1Q","qr":"Advt_qr__9ydlB","socials":"Advt_socials__0t0z4","advtIcon":"Advt_advtIcon__AzjsE"};